const meta = {
  create: {
    display: 'hidden',
  },
};

export default meta;
